import { PartnerTermsResponse } from "../contracts/PartnerTermsResponse";
import { PartnerTerms } from "../models/PartnerTerms";

export const mapResponseToPartnerTerms = (response: PartnerTermsResponse): PartnerTerms => ({
  partnerName: response.partnerName,
  currentTermsVersion: response.currentTermsVersion,
  accepted: response.accepted,
  acceptedAt: response.acceptedAt ? new Date(response.acceptedAt) : null,
  code: response.code,
});
